var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-signin",attrs:{"id":"linkedin-circle"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"circle-logo",attrs:{"src":"/static/images/signin/linkedin/linkedin-icon.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b924d12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LinkedInCircle.vue
// module id = Wwu7
// module chunks = 1